import React, { useState, useRef, useEffect } from 'react';
import { Dialog, Button, DialogTitle, DialogContent, DialogActions, Tab, IconButton, Tooltip, Typography, Card, CardContent, Modal, Grid, Stack, FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import { Box } from '@mui/system';
import { DataGrid, GridToolbarQuickFilter, GridActionsCellItem } from '@mui/x-data-grid';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { CustomButton } from '../../common/custom-button/customButton';

import { loaderService } from '../../common/custom-loader/loader-service';
import { toast } from 'react-toastify';
import { FETCH_MAPPINGS, GET_APPROVED_STAKEHOLDERS, GET_SHORTLISTED_STAKEHOLDERS, GET_STAKEHOLDER_BY_TYPE, LIST_OF_IS_LLE_GROWER, SAVE_SHORTLISTED_STAKEHOLDERS, GET_GROWER_CLUSTER, CREATE_GROWER_CLUSTER } from '../../common/URLs';
import { FinancialYearDropdown } from './FinancialYearDropdown';
import { async } from 'q';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import { DEMAND_CONSTANTS, PROD } from '../../common/constants';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { lastFiveDigitsComparator } from '../../common/commonFunction';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { QuickSearchToolbar } from '../../payment/common/commonFunctions';
import { useTranslation } from 'react-i18next';
import { ClusterIcon, FetchIcon, ShortlistIcon, ViewIcon } from '../../common/icons';
import apiClient from '../../axios';

export const GrowerClustering = () => {
    const { t } = useTranslation();
    const [tabValue, setTabValue] = React.useState('1');
    const [open, setOpen] = React.useState(false);
    const uuid = localStorage.getItem('uuid');
    const [stakeholderCommonData, setStakeholderCommonData] = React.useState([]);

    const [selectedFinancialYear, setSelectedFinancialYear] = useState('');
    const [selectedFinancialYearErr, setSelectedFinancialYearErr] = useState();
    const [selectedShortlistedFinancialYear, setSelectedShortlistedFinancialYear] = useState('');

    const [shortlistedGrowerList, setShortlistedGrowerList] = React.useState([]);
    const [createdClusterDetails, setCreatedClusterDetails] = useState();

    const [planningMonth, setPlanningMonth] = useState('Jan');
    const [shortlistedPlanningMonth, setShortlistedPlanningMonth] = useState('Jan');
    const [pageSize, setPageSize] = React.useState(10);
    const monthArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

    const [lleIsList, setLleIsList] = useState();
    const [growerCluster, setGrowerCluster] = useState();

    const [selectionModel, setSelectionModel] = useState([]);
    const [groupedData, setGroupedData] = useState([]);

    const [lleClusterLst, setLleClusterLst] = useState([]);
    const [fetchMappingStakeholdersList, setFetchMappingStakeholdersList] = React.useState([]);

    const [selectedLLe, setSelectedLLe] = useState([]);

    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);

    const [fetchMappingsDialog, setFetchMappingsDialog] = useState(false);
    const handleFetchMappingsDialogOpen = () => setFetchMappingsDialog(true);
    const handleFetchMappingsDialogClose = () => setFetchMappingsDialog(false);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        setSelectedLLe([]);
        setSelectedFinancialYear('');
        setSelectedShortlistedFinancialYear('');
        setShortlistedGrowerList([]);
    };

    const handlePlanningMonthChnage = (event) => {
        setPlanningMonth(event.target.value);
        getShortlistedStakeholdersShortlistingApi(selectedFinancialYear, event.target.value);
    };
    const handleShortlistedPlanningMonthChnage = (event) => {
        setShortlistedPlanningMonth(event.target.value);
        getShortlistedStakeholdersShortlistingApi(selectedShortlistedFinancialYear, event.target.value);
    };

    const getSelectedValue = (dataToBePassed) => {
        setSelectedFinancialYear(dataToBePassed);
        setSelectedFinancialYearErr('');
        getShortlistedStakeholdersShortlistingApi(dataToBePassed, planningMonth);
    }


    const getSelectedValueShortlisted = (dataToBePassed) => {
        setSelectedShortlistedFinancialYear(dataToBePassed);
        getShortlistedStakeholdersShortlistingApi(dataToBePassed, planningMonth);

    }



    const LLE_IS_Col = [
        {
            field: 'stakeholderName',
            headerName: t('preReg.name'),
            width: 150,

        },
        {
            field: 'stakeholderUrn',
            headerName: 'URN',
            width: 150,

        },
        {
            field: 'stakeholderDistrict',
            headerName: 'District',
            width: 150,

        },
        {
            field: 'stakeholderState',
            headerName: 'State',
            width: 150,

        },
        {
            field: 'stakeholderPincode',
            headerName: 'Pincode',
            width: 100,
            // sortComparator: (a, b) => lastFiveDigitsComparator(a, b)
        },
        {
            field: 'shortlist',
            headerName: 'Shortlist Growers',
            type: 'action',
            width: 150,
            renderCell: (params) => {
                return (
                    <Tooltip title="View">
                        <IconButton variant="contained"
                            color="primary"
                            disabled={!selectedLLe.includes(params.row.stakeholderUrn)}
                            onClick={(e) => handleClickOpen(params.row)}
                        >
                            <ViewIcon />
                        </IconButton>
                    </Tooltip>
                );
            }
        },

    ];

    const ShortlistedCol = [
        {
            field: 'stakeholderName',
            headerName: t('preReg.name'),
            width: 150,

        },
        {
            field: 'stakeholderUrn',
            headerName: 'URN',
            width: 150,

        },
        {
            field: 'stakeholderDistrict',
            headerName: 'District',
            width: 150,

        },
        {
            field: 'stakeholderState',
            headerName: 'State',
            width: 150,

        },
        {
            field: 'stakeholderPincode',
            headerName: 'Pincode',
            width: 100,
            // sortComparator: (a, b) => lastFiveDigitsComparator(a, b)
        },
        {
            field: 'shortlist',
            headerName: 'Shortlist Growers',
            type: 'action',
            width: 150,
            renderCell: (params) => {
                return (
                    <Tooltip title="View">
                        <IconButton variant="contained"
                            color="primary"
                            onClick={(e) => handleClickOpen(params.row)}
                        >
                            <ViewIcon />
                        </IconButton>
                    </Tooltip>
                );
            }
        },

    ];

    useEffect(() => {
        getStakeholderByTypeApi();
        getGrowerCluster();
    }, []);


    const getStakeholderByTypeApi = async () => {
        loaderService.showLoader();
        await apiClient.post(GET_APPROVED_STAKEHOLDERS,
            {
                type: 'lle'
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                const temp = response.data.stakeHolders?.map((data) => {
                    let tempData = { ...data }
                    tempData.stakeHolderType = 'LLE'
                    return tempData
                })
                getStakeholderByTypeISApi(temp);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const getStakeholderByTypeISApi = async (lleApiData) => {
        loaderService.showLoader();
        await apiClient.post(GET_APPROVED_STAKEHOLDERS,
            {
                type: 'Interim Storage Operator'
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                const temp = response.data.stakeHolders?.map((data) => {
                    let tempData = { ...data }
                    tempData.stakeHolderType = 'IS'
                    return tempData
                })
                let mergedData = [...temp, ...lleApiData]
                setStakeholderCommonData(mergedData);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }



    const onConfirmShortlist = (e) => {
        handleConfirmClose();
        onShortlist(e);
    }

    const onShortListButtonClick = (e) => {
        if (lleClusterLst?.length === 0) {
            toast.error("Select at least one URN and add growers to Shortlist!")
        }
        else if (lleClusterLst?.length != 0) {
            lleClusterLst?.every(obj => {
                if (obj.growerClusterLst.length === 0) {
                    toast.error(`${obj.stakeholderUrn} has no grower selected! Either remove ${obj.stakeholderType} or add growers for shortlisting.`)
                }
                else if (obj.growerClusterLst.length != 0) {
                    handleConfirmOpen();
                }
            })
        }
    }

    const onShortlist = () => {
        loaderService.showLoader();
        apiClient
            .post(SAVE_SHORTLISTED_STAKEHOLDERS,
                {
                    "financialYear": selectedFinancialYear,
                    "month": planningMonth,
                    "lleClusterLst": lleClusterLst
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                if (response.data?.isSuccess === true) {
                    toast.success(response.data?.message)
                    setLleClusterLst([]);
                }
                else {
                    toast.error(response.data?.message ? response.data?.message : "Error")
                }
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const handleClickOpen = (row) => {
        setOpen(true);
        setGrowerCluster(row);
        setSelectionModel(lleClusterLst.flatMap(obj =>
            obj.growerClusterLst.flatMap(grower =>
                grower.growers.map(item => item.growerLandId)
            )
        ));
    };

    const lleIs = stakeholderCommonData?.map((item) => {
        let data = {
            "urnNumber": item.urn,
            "type": item.stakeHolderType,
            "name": item.name,
            "state": item.state,
            "district": item.district,
            "pincode": item.pincode
        }
        return data
    })

    const onCreateGrowerCluster = () => {
        loaderService.showLoader();
        apiClient
            .post(CREATE_GROWER_CLUSTER,
                {
                    "listOfIsOrLleReqst": lleIs
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setCreatedClusterDetails(response.data)
                if (response.data?.isSuccess === true) {
                    toast.success(response.data?.message)
                }
                else {
                    toast.error(response.data?.message ? response.data?.message : "Error")
                }
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const getGrowerCluster = () => {
        loaderService.showLoader();
        apiClient
            .post(
                GET_GROWER_CLUSTER,
                {},
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                }
            )
            .then((response) => {
                setLleIsList(response.data.lleClusterLst);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log("apiClientERROR", error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    const getShortlistedStakeholdersShortlistingApi = async (year, month) => {
        loaderService.showLoader();
        let data = {
            "financialYear": year,
            "month": month,
        }
        await apiClient.post(GET_SHORTLISTED_STAKEHOLDERS,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setShortlistedGrowerList(response.data.lleClusterLst);
                setLleClusterLst(...lleClusterLst, response.data.lleClusterLst);
                setSelectedLLe(response.data.lleClusterLst.map(item => item.stakeholderUrn))
                // let mappingData = response.data?.lleClusterLst?.map((item) => {
                //     return {
                //         "urnNumber": item.stakeholderUrn,
                //         "type": item.stakeholderType,
                //         "lleClusterLst": lleClusterLst
                //     }
                // })
                // setFetchMappingStakeholdersList(mappingData);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const onConfirmFetchMappings = () => {
        handleFetchMappingsDialogClose();
        loaderService.showLoader();
        let data = {
            "financialYear": selectedShortlistedFinancialYear,
            "month": shortlistedPlanningMonth,
            "lleClusterLst": lleClusterLst
        }
        apiClient.post(FETCH_MAPPINGS + `?userId=${uuid}`,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                if (response.data.isSuccess === true) toast.success(response.data.message);
                else toast.error(response.data.message);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const fetchMappingsApi = () => {
        if (lleClusterLst?.length === 0) toast.info(DEMAND_CONSTANTS.NoDataUpdated)
        else {
            handleFetchMappingsDialogOpen();
        }
    }

    const handleClose = (newValue) => {
        setOpen(false);
    };

    const growerColumns = [
        {
            field: 'growerUrn',
            headerName: 'Grower Urn',
            width: 130
        },
        {
            field: 'landName',
            headerName: 'Land Name',
            width: 170
        },
        {
            field: 'growerLandId',
            headerName: 'Land Id',
            width: 250
        },
        {
            field: 'revenueCircle',
            headerName: 'Revenue Circle',
            width: 190
        },

    ]

    const onSelectionModelChangeCallback = (value) => {
        setSelectedLLe(value);
    };

    useEffect(() => {
        if(!Array.isArray(lleClusterLst)) {
            setLleClusterLst([]);
            return;
        }
        let filteredList = lleClusterLst?.filter(item => selectedLLe?.includes(item.stakeholderUrn));
        setLleClusterLst(filteredList);
    }, [selectedLLe]);

    const handleModalShortlistBtn = (e) => {
        e.preventDefault();
        let tempArr = {
            "stakeholderUrn": growerCluster.stakeholderUrn,
            "stakeholderType": growerCluster.stakeholderType,
            "stakeholderName": growerCluster.stakeholderName,
            "stakeholderState": growerCluster.stakeholderState,
            "stakeholderDistrict": growerCluster.stakeholderDistrict,
            "stakeholderPincode": growerCluster.stakeholderPincode,
            "growerClusterLst": groupedData
        }
        let found = false;
        const updatedList = lleClusterLst.map((cluster) => {
            if (cluster.stakeholderUrn === growerCluster.stakeholderUrn) {
                found = true;
                return { ...cluster, ...tempArr }; // Updates the existing cluster with incoming data
            }
            return cluster;
        });

        if (!found) {
            setLleClusterLst([...updatedList, tempArr]); // Adds new cluster if URN not found
        } else {
            setLleClusterLst(updatedList); // Updates the state if URN is found
        }
        handleClose();
    }
    // console.log("lleClusterLst", lleClusterLst)

    const groupByClusterId = (dataArray) => {
        const grouped = dataArray.reduce((acc, item) => {
            const { clusterId, growerUrn, growerLandId, revenueCircle } = item;
            acc[clusterId] = acc[clusterId] || [];
            acc[clusterId].push({ growerUrn, growerLandId, revenueCircle });
            return acc;
        }, {});

        return Object.entries(grouped).map(([key, value]) => ({
            clusterId: key,
            growers: value
        }));
    };

    const onGrowerSelectionCallback = (value) => {
        let newobj = []
        growerCluster?.growerClusterLst?.forEach(cluster => {
            cluster.growers.forEach((item) => {
                if (value.includes(item.growerLandId)) {
                    newobj.push({
                        "clusterId": cluster.clusterId,
                        "growerUrn": item.growerUrn,
                        "growerLandId": item.growerLandId,
                        "revenueCircle": item.revenueCircle
                    })
                }
            })
        })
        setSelectionModel(value);
        const grouped = groupByClusterId(newobj);
        setGroupedData(grouped);
    }

    const dialogSection = () => {
        return (
            <Dialog onClose={handleClose} open={open} maxWidth='md' fullWidth={true}>

                <DialogTitle> Shortlist Stakeholder </DialogTitle>
                <DialogContent>
                    {growerCluster?.growerClusterLst?.map((item) => {
                        return (
                            <Accordion >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                    id={item?.clusterId}
                                    key={item?.clusterId}
                                    style={{ backgroundColor: '#F5F5F5' }}
                                >
                                    <Typography style={{ fontWeight: 'bold' }}>{item?.clusterId}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    {
                                        item?.growers &&
                                        <Box sx={{ height: 400, width: '100%' }}>
                                            <DataGrid
                                                rows={item?.growers}
                                                getRowId={(row) => row?.growerLandId}
                                                columns={growerColumns}
                                                checkboxSelection={tabValue != "2"}
                                                onSelectionModelChange={(e) => onGrowerSelectionCallback(e)}
                                                selectionModel={selectionModel}
                                                disableSelectionOnClick
                                                experimentalFeatures={{ newEditingApi: true }}
                                                pageSize={pageSize}
                                                onPageSizeChange={(newPage) => setPageSize(newPage)}
                                                components={{ Toolbar: QuickSearchToolbar }}
                                            />
                                        </Box>
                                    }
                                </AccordionDetails>

                            </Accordion>
                        )
                    })}

                </DialogContent>
                <DialogActions>
                    <Button sx={{ minWidth: 100 }} variant="contained" type='submit'
                        hidden={tabValue === "2"}
                        onClick={(e) => handleModalShortlistBtn(e)}
                    >Shortlist
                    </Button>
                </DialogActions>
            </Dialog>

        )
    }



    return (
        <TabContext value={tabValue}>
            {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>DEM02</p>}
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                    <Tab label="Shortlisting" value="1" />
                    <Tab label="Shortlisted" value="2" />
                </TabList>
            </Box>
            <TabPanel value="1">
                <Card>
                    <CardContent>
                        <Stack direction='row' spacing={1} style={{ marginBottom: 5 }}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} lg={3}>
                                    <FinancialYearDropdown selectedValue={getSelectedValue} helperText={selectedFinancialYearErr} />
                                </Grid>
                                <Grid item xs={12} lg={3}>

                                    <FormControl fullWidth size="small" >
                                        <InputLabel id="demo-simple-select-helper-label">Planning Month</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-helper-label"
                                            id="demo-simple-select-helper"
                                            value={tabValue === '1' ? planningMonth : shortlistedPlanningMonth}
                                            label="Planning Month"
                                            onChange={tabValue === '1' ? handlePlanningMonthChnage : handleShortlistedPlanningMonthChnage}
                                        >
                                            {monthArray.map((item) =>
                                                <MenuItem key={item} value={item}>{item}</MenuItem>
                                            )}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} lg={6}>
                                    <Box display='flex' alignItems="center" justifyContent="center" style={{ float: "right" }}>
                                        <Button startIcon={<ClusterIcon />} variant='contained' sx={{ minWidth: 100 }} onClick={(e) => onCreateGrowerCluster(e)}>
                                            Create Grower Cluster
                                        </Button>
                                        <Button startIcon={<ShortlistIcon />} variant='contained' sx={{ ml: 1, minWidth: 100 }} disabled={selectedFinancialYear === ''} onClick={(e) => onShortListButtonClick(e)}>
                                            Shortlist
                                        </Button>
                                    </Box>

                                </Grid>
                            </Grid>
                        </Stack>
                        {
                            lleIsList &&
                            <Box sx={{ height: 400, width: '100%', marginTop: "3vh" }}>
                                <DataGrid
                                    rows={lleIsList}
                                    columns={LLE_IS_Col}
                                    getRowId={(row) => row?.stakeholderUrn}
                                    checkboxSelection
                                    components={{ Toolbar: QuickSearchToolbar }}
                                    onSelectionModelChange={(e) => onSelectionModelChangeCallback(e)}
                                    selectionModel={selectedLLe}
                                    disableSelectionOnClick
                                    experimentalFeatures={{ newEditingApi: true }}
                                    pageSize={pageSize}
                                    onPageSizeChange={(newPage) => setPageSize(newPage)}
                                />
                            </Box>
                        }
                        {dialogSection()}
                    </CardContent>
                </Card>
            </TabPanel>
            <TabPanel value='2'>
                <Card>
                    <CardContent>
                        <Stack direction='row' spacing={1} style={{ marginBottom: 5 }}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} lg={3}>
                                    <FinancialYearDropdown selectedValue={getSelectedValueShortlisted} />                                </Grid>
                                <Grid item xs={12} lg={3}>

                                    <FormControl fullWidth size="small" >
                                        <InputLabel id="demo-simple-select-helper-label">Planning Month</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-helper-label"
                                            id="demo-simple-select-helper"
                                            value={tabValue === '1' ? planningMonth : shortlistedPlanningMonth}
                                            label="Planning Month"
                                            onChange={tabValue === '1' ? handlePlanningMonthChnage : handleShortlistedPlanningMonthChnage}
                                        >
                                            {monthArray.map((item) =>
                                                <MenuItem key={item} value={item}>{item}</MenuItem>
                                            )}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} lg={6}>
                                    <Box display='flex' alignItems="center" justifyContent="center" style={{ float: "right" }}>
                                        <Button startIcon={<FetchIcon />} variant='contained' sx={{ ml: 1, minWidth: 100 }} disabled={selectedShortlistedFinancialYear === ''} onClick={() => fetchMappingsApi()}>
                                            Fetch Mappings
                                        </Button>
                                    </Box>

                                </Grid>
                            </Grid>
                        </Stack>
                        {
                            shortlistedGrowerList &&
                            <Box sx={{ height: 400, width: '100%', marginTop: "3vh" }}>
                                <DataGrid
                                    rows={shortlistedGrowerList}
                                    columns={ShortlistedCol}
                                    getRowId={(row) => row?.stakeholderUrn}
                                    components={{ Toolbar: QuickSearchToolbar }}
                                    experimentalFeatures={{ newEditingApi: true }}
                                    pageSize={pageSize}
                                    onPageSizeChange={(newPage) => setPageSize(newPage)}
                                />
                            </Box>
                        }
                        {dialogSection()}
                    </CardContent>
                </Card>
            </TabPanel>
            <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmShortlist} onClose={handleConfirmClose} action="Shortlist" />
            <ConfirmationPopover onOpen={fetchMappingsDialog} onConfirm={onConfirmFetchMappings} onClose={handleFetchMappingsDialogClose} action="Fetch Mappings" />
        </TabContext>
    )
}